import React from "react";

import RenderWhen from "../../../../../components/RenderWhen";
import { HistoryProps } from "../../../@types/rldynamicanalysis/";
import { RLcsAnalysisResponseData } from "../hooks/useRlcsAnalysisStatus";
import HistoryTable from "./HistoryTable";
import HistoryTitle from "./HistoryTitle";

type Props = HistoryProps & { status: RLcsAnalysisResponseData };

const History = (props: Props) => (
  <RenderWhen condition={Boolean(props.data)}>
    <HistoryTitle status={props.status} />
    <HistoryTable
      data={props.data}
      hash={props.hash}
      onReportClick={props.onReportClick}
      isStoredReport={props.isStoredReport}
      isNetworkReport={props.isNetworkReport}
    />
  </RenderWhen>
);

export default History;
